import React from "react";

const Certificate = () => {
  return (
    <section className="section linear-gradient-2" id="certificate">
      <div className="info">
        <h2>EF SET Certificate</h2>
        <p>
          Receive a free personalized online English certificate when you take
          the 50-minute English test. You can easily add it to your CV or
          LinkedIn profile.
        </p>
        <button>Certify your English level</button>
      </div>
      <div className="hero">
        <img
          src="https://a.storyblok.com/f/79503/468x467/2531d03856/certificate-image-desktop.svg"
          alt="img2"
        />
      </div>
    </section>
  );
};

export default Certificate;
